import { Space } from "antd";
import { FC } from "react";
import styles from "./styles.module.css";

const IMAGES = [
  {
    src: "/images/landing/talent_protocol.png",
    href: "https://www.talentprotocol.com/",
  },
  {
    src: "/images/landing/aag.png",
    href: "https://aag.ventures/",
  },
  {
    src: "/images/landing/aurora.png",
    href: "https://aurora.dev/",
  },
  {
    src: "/images/landing/w.png",
    href: "https://www.warena.io/",
  },
];

const Partner: FC = () => {
  return (
    <div className={styles.root}>
      <div className="container-lg">
        <div className={styles.content}>
          <h3>Our Partners:</h3>

          <div className={styles.marquee}>
            {IMAGES.map((x) => (
              <div key={x.src}>
                <a href={x.href} target="_blank" rel="noopener noreferrer">
                  <img src={x.src} alt="image" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partner;
